module.exports = __webpack_public_path__ + "fonts/museo-sans-300-webfont.812f700.ttf";